export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '4c10a60', dateTime: 1780105164056 };